export default [
  {
    name: 'Andorra',
    code: 'AD',
    locale: 'ca-AD',
    currency: 'EUR',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    locale: 'ar-AE',
    currency: 'AED',
  },
  {
    name: 'Afghanistan',
    code: 'AF',
    locale: 'fa-AF',
    currency: 'AFN',
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
    locale: 'en-AG',
    currency: 'XCD',
  },
  {
    name: 'Anguilla',
    code: 'AI',
    locale: 'en-AI',
    currency: 'XCD',
  },
  {
    name: 'Albania',
    code: 'AL',
    locale: 'sq-AL',
    currency: 'ALL',
  },
  {
    name: 'Armenia',
    code: 'AM',
    locale: 'hy-AM',
    currency: 'AMD',
  },
  {
    name: 'Angola',
    code: 'AO',
    locale: 'pt-AO',
    currency: 'AOA',
  },
  {
    name: 'Antarctica',
    code: 'AQ',
    locale: 'en-AQ',
    currency: 'USD',
  },
  {
    name: 'Argentina',
    code: 'AR',
    locale: 'es-AR',
    currency: 'ARS',
  },
  {
    name: 'American Samoa',
    code: 'AS',
    locale: 'en-AS',
    currency: 'USD',
  },
  {
    name: 'Austria',
    code: 'AT',
    zone: 'eu',
    locale: 'de-AT',
    currency: 'EUR',
  },
  {
    name: 'Australia',
    code: 'AU',
    zone: 'us',
    locale: 'en-AU',
    currency: 'AUD',
  },
  {
    name: 'Aruba',
    code: 'AW',
    locale: 'nl-AW',
    currency: 'AWG',
  },
  {
    name: 'Åland',
    code: 'AX',
    locale: 'sv-AX',
    currency: 'EUR',
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
    locale: 'az-AZ',
    currency: 'AZN',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    locale: 'bs-BA',
    currency: 'BAM',
  },
  {
    name: 'Barbados',
    code: 'BB',
    locale: 'en-BB',
    currency: 'BBD',
  },
  {
    name: 'Bangladesh',
    code: 'BD',
    locale: 'bn-BD',
    currency: 'BDT',
  },
  {
    name: 'Belgium',
    code: 'BE',
    zone: 'eu',
    locale: 'nl-BE',
    currency: 'EUR',
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
    locale: 'fr-BF',
    currency: 'XOF',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    zone: 'eu',
    locale: 'bg-BG',
    currency: 'BGN',
  },
  {
    name: 'Bahrain',
    code: 'BH',
    locale: 'ar-BH',
    currency: 'BHD',
  },
  {
    name: 'Burundi',
    code: 'BI',
    locale: 'fr-BI',
    currency: 'BIF',
  },
  {
    name: 'Benin',
    code: 'BJ',
    locale: 'fr-BJ',
    currency: 'XOF',
  },
  {
    name: 'Saint Barthélemy',
    code: 'BL',
    locale: 'fr-BL',
    currency: 'EUR',
  },
  {
    name: 'Bermuda',
    code: 'BM',
    locale: 'en-BM',
    currency: 'BMD',
  },
  {
    name: 'Brunei',
    code: 'BN',
    locale: 'ms-BN',
    currency: 'BND',
  },
  {
    name: 'Bolivia',
    code: 'BO',
    locale: 'es-BO',
    currency: 'BOB',
  },
  {
    name: 'Bonaire',
    code: 'BQ',
    locale: 'nl-BQ',
    currency: 'USD',
  },
  {
    name: 'Brazil',
    code: 'BR',
    locale: 'pt-BR',
    currency: 'BRL',
  },
  {
    name: 'Bahamas',
    code: 'BS',
    locale: 'en-BS',
    currency: 'BSD',
  },
  {
    name: 'Bhutan',
    code: 'BT',
    locale: 'dz-BT',
    currency: 'BTN',
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
    locale: 'en-BV',
    currency: 'NOK',
  },
  {
    name: 'Botswana',
    code: 'BW',
    locale: 'en-BW',
    currency: 'BWP',
  },
  {
    name: 'Belarus',
    code: 'BY',
    locale: 'be-BY',
    currency: 'BYN',
  },
  {
    name: 'Belize',
    code: 'BZ',
    locale: 'en-BZ',
    currency: 'BZD',
  },
  {
    name: 'Canada',
    code: 'CA',
    locale: 'en-CA',
    currency: 'CAD',
  },
  {
    name: 'Cocos [Keeling] Islands',
    code: 'CC',
    locale: 'en-CC',
    currency: 'AUD',
  },
  {
    name: 'Democratic Republic of the Congo',
    code: 'CD',
    locale: 'fr-CD',
    currency: 'CDF',
  },
  {
    name: 'Central African Republic',
    code: 'CF',
    locale: 'fr-CF',
    currency: 'XAF',
  },
  {
    name: 'Republic of the Congo',
    code: 'CG',
    locale: 'fr-CG',
    currency: 'XAF',
  },
  {
    name: 'Switzerland',
    code: 'CH',
    locale: 'de-CH',
    currency: 'CHF',
  },
  {
    name: 'Ivory Coast',
    code: 'CI',
    locale: 'fr-CI',
    currency: 'XOF',
  },
  {
    name: 'Cook Islands',
    code: 'CK',
    locale: 'en-CK',
    currency: 'NZD',
  },
  {
    name: 'Chile',
    code: 'CL',
    locale: 'es-CL',
    currency: 'CLP',
  },
  {
    name: 'Cameroon',
    code: 'CM',
    locale: 'fr-CM',
    currency: 'XAF',
  },
  {
    name: 'China',
    code: 'CN',
    locale: 'zh-CN',
    currency: 'CNY',
  },
  {
    name: 'Colombia',
    code: 'CO',
    locale: 'es-CO',
    currency: 'COP',
  },
  {
    name: 'Costa Rica',
    code: 'CR',
    locale: 'es-CR',
    currency: 'CRC',
  },
  {
    name: 'Cuba',
    code: 'CU',
    locale: 'es-CU',
    currency: 'CUP',
  },
  {
    name: 'Cape Verde',
    code: 'CV',
    locale: 'pt-CV',
    currency: 'CVE',
  },
  {
    name: 'Curacao',
    code: 'CW',
    locale: 'nl-CW',
    currency: 'ANG',
  },
  {
    name: 'Christmas Island',
    code: 'CX',
    locale: 'en-CX',
    currency: 'AUD',
  },
  {
    name: 'Cyprus',
    code: 'CY',
    zone: 'eu',
    locale: 'el-CY',
    currency: 'EUR',
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    zone: 'eu',
    locale: 'cs-CZ',
    currency: 'CZK',
  },
  {
    name: 'Germany',
    code: 'DE',
    zone: 'eu',
    locale: 'de-DE',
    currency: 'EUR',
  },
  {
    name: 'Djibouti',
    code: 'DJ',
    locale: 'fr-DJ',
    currency: 'DJF',
  },
  {
    name: 'Denmark',
    code: 'DK',
    zone: 'eu',
    locale: 'da-DK',
    currency: 'DKK',
  },
  {
    name: 'Dominica',
    code: 'DM',
    locale: 'en-DM',
    currency: 'XCD',
  },
  {
    name: 'Dominican Republic',
    code: 'DO',
    locale: 'es-DO',
    currency: 'DOP',
  },
  {
    name: 'Algeria',
    code: 'DZ',
    locale: 'ar-DZ',
    currency: 'DZD',
  },
  {
    name: 'Ecuador',
    code: 'EC',
    locale: 'es-EC',
    currency: 'USD',
  },
  {
    name: 'Estonia',
    code: 'EE',
    zone: 'eu',
    locale: 'et-EE',
    currency: 'EUR',
  },
  {
    name: 'Egypt',
    code: 'EG',
    locale: 'ar-EG',
    currency: 'EGP',
  },
  {
    name: 'Western Sahara',
    code: 'EH',
    locale: 'ar-EH',
    currency: 'MAD',
  },
  {
    name: 'Eritrea',
    code: 'ER',
    locale: 'ti-ER',
    currency: 'ERN',
  },
  {
    name: 'Spain',
    code: 'ES',
    zone: 'eu',
    locale: 'es-ES',
    currency: 'EUR',
  },
  {
    name: 'Ethiopia',
    code: 'ET',
    locale: 'am-ET',
    currency: 'ETB',
  },
  {
    name: 'Finland',
    code: 'FI',
    zone: 'eu',
    locale: 'fi-FI',
    currency: 'EUR',
  },
  {
    name: 'Fiji',
    code: 'FJ',
    locale: 'en-FJ',
    currency: 'FJD',
  },
  {
    name: 'Falkland Islands',
    code: 'FK',
    locale: 'en-FK',
    currency: 'FKP',
  },
  {
    name: 'Micronesia',
    code: 'FM',
    locale: 'en-FM',
    currency: 'USD',
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
    locale: 'fo-FO',
    currency: 'DKK',
  },
  {
    name: 'France',
    code: 'FR',
    zone: 'eu',
    locale: 'fr-FR',
    currency: 'EUR',
  },
  {
    name: 'Gabon',
    code: 'GA',
    locale: 'fr-GA',
    currency: 'XAF',
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    zone: 'us',
    locale: 'en-GB',
    currency: 'GBP',
  },
  {
    name: 'Grenada',
    code: 'GD',
    locale: 'en-GD',
    currency: 'XCD',
  },
  {
    name: 'Georgia',
    code: 'GE',
    locale: 'ka-GE',
    currency: 'GEL',
  },
  {
    name: 'French Guiana',
    code: 'GF',
    locale: 'fr-GF',
    currency: 'EUR',
  },
  {
    name: 'Guernsey',
    code: 'GG',
    locale: 'en-GG',
    currency: 'GBP',
  },
  {
    name: 'Ghana',
    code: 'GH',
    locale: 'en-GH',
    currency: 'GHS',
  },
  {
    name: 'Gibraltar',
    code: 'GI',
    locale: 'en-GI',
    currency: 'GIP',
  },
  {
    name: 'Greenland',
    code: 'GL',
    locale: 'kl-GL',
    currency: 'DKK',
  },
  {
    name: 'Gambia',
    code: 'GM',
    locale: 'en-GM',
    currency: 'GMD',
  },
  {
    name: 'Guinea',
    code: 'GN',
    locale: 'fr-GN',
    currency: 'GNF',
  },
  {
    name: 'Guadeloupe',
    code: 'GP',
    locale: 'fr-GP',
    currency: 'EUR',
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
    locale: 'es-GQ',
    currency: 'XAF',
  },
  {
    name: 'Greece',
    code: 'GR',
    zone: 'eu',
    locale: 'el-GR',
    currency: 'EUR',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
    locale: 'en-GS',
    currency: 'GBP',
  },
  {
    name: 'Guatemala',
    code: 'GT',
    locale: 'es-GT',
    currency: 'GTQ',
  },
  {
    name: 'Guam',
    code: 'GU',
    locale: 'en-GU',
    currency: 'USD',
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
    locale: 'pt-GW',
    currency: 'XOF',
  },
  {
    name: 'Guyana',
    code: 'GY',
    locale: 'en-GY',
    currency: 'GYD',
  },
  {
    name: 'Hong Kong',
    code: 'HK',
    locale: 'zh-HK',
    currency: 'HKD',
  },
  {
    name: 'Heard Island and McDonald Islands',
    code: 'HM',
    locale: 'en-HM',
    currency: 'AUD',
  },
  {
    name: 'Honduras',
    code: 'HN',
    locale: 'es-HN',
    currency: 'HNL',
  },
  {
    name: 'Croatia',
    code: 'HR',
    zone: 'eu',
    locale: 'hr-HR',
    currency: 'EUR',
  },
  {
    name: 'Haiti',
    code: 'HT',
    locale: 'fr-HT',
    currency: 'HTG',
  },
  {
    name: 'Hungary',
    code: 'HU',
    zone: 'eu',
    locale: 'hu-HU',
    currency: 'HUF',
  },
  {
    name: 'Indonesia',
    code: 'ID',
    locale: 'id-ID',
    currency: 'IDR',
  },
  {
    name: 'Ireland',
    code: 'IE',
    zone: 'eu',
    locale: 'en-IE',
    currency: 'EUR',
  },
  {
    name: 'Israel',
    code: 'IL',
    locale: 'he-IL',
    currency: 'ILS',
  },
  {
    name: 'Isle of Man',
    code: 'IM',
    locale: 'en-IM',
    currency: 'GBP',
  },
  {
    name: 'India',
    code: 'IN',
    locale: 'hi-IN',
    currency: 'INR',
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    locale: 'en-IO',
    currency: 'USD',
  },
  {
    name: 'Iraq',
    code: 'IQ',
    locale: 'ar-IQ',
    currency: 'IQD',
  },
  {
    name: 'Iran',
    code: 'IR',
    locale: 'fa-IR',
    currency: 'IRR',
  },
  {
    name: 'Iceland',
    code: 'IS',
    locale: 'is-IS',
    currency: 'ISK',
  },
  {
    name: 'Italy',
    code: 'IT',
    zone: 'eu',
    locale: 'it-IT',
    currency: 'EUR',
  },
  {
    name: 'Jersey',
    code: 'JE',
    locale: 'en-JE',
    currency: 'GBP',
  },
  {
    name: 'Jamaica',
    code: 'JM',
    locale: 'en-JM',
    currency: 'JMD',
  },
  {
    name: 'Jordan',
    code: 'JO',
    locale: 'ar-JO',
    currency: 'JOD',
  },
  {
    name: 'Japan',
    code: 'JP',
    locale: 'ja-JP',
    currency: 'JPY',
  },
  {
    name: 'Kenya',
    code: 'KE',
    locale: 'sw-KE',
    currency: 'KES',
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG',
    locale: 'ky-KG',
    currency: 'KGS',
  },
  {
    name: 'Cambodia',
    code: 'KH',
    locale: 'km-KH',
    currency: 'KHR',
  },
  {
    name: 'Kiribati',
    code: 'KI',
    locale: 'en-KI',
    currency: 'AUD',
  },
  {
    name: 'Comoros',
    code: 'KM',
    locale: 'ar-KM',
    currency: 'KMF',
  },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
    locale: 'en-KN',
    currency: 'XCD',
  },
  {
    name: 'North Korea',
    code: 'KP',
    locale: 'ko-KP',
    currency: 'KPW',
  },
  {
    name: 'South Korea',
    code: 'KR',
    locale: 'ko-KR',
    currency: 'KRW',
  },
  {
    name: 'Kuwait',
    code: 'KW',
    locale: 'ar-KW',
    currency: 'KWD',
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
    locale: 'en-KY',
    currency: 'KYD',
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
    locale: 'kk-KZ',
    currency: 'KZT',
  },
  {
    name: 'Laos',
    code: 'LA',
    locale: 'lo-LA',
    currency: 'LAK',
  },
  {
    name: 'Lebanon',
    code: 'LB',
    locale: 'ar-LB',
    currency: 'LBP',
  },
  {
    name: 'Saint Lucia',
    code: 'LC',
    locale: 'en-LC',
    currency: 'XCD',
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
    locale: 'de-LI',
    currency: 'CHF',
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
    locale: 'si-LK',
    currency: 'LKR',
  },
  {
    name: 'Liberia',
    code: 'LR',
    locale: 'en-LR',
    currency: 'LRD',
  },
  {
    name: 'Lesotho',
    code: 'LS',
    locale: 'en-LS',
    currency: 'LSL',
  },
  {
    name: 'Lithuania',
    code: 'LT',
    zone: 'eu',
    locale: 'lt-LT',
    currency: 'EUR',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    zone: 'eu',
    locale: 'fr-LU',
    currency: 'EUR',
  },
  {
    name: 'Latvia',
    code: 'LV',
    zone: 'eu',
    locale: 'lv-LV',
    currency: 'EUR',
  },
  {
    name: 'Libya',
    code: 'LY',
    locale: 'ar-LY',
    currency: 'LYD',
  },
  {
    name: 'Morocco',
    code: 'MA',
    locale: 'ar-MA',
    currency: 'MAD',
  },
  {
    name: 'Monaco',
    code: 'MC',
    locale: 'fr-MC',
    currency: 'EUR',
  },
  {
    name: 'Moldova',
    code: 'MD',
    locale: 'ro-MD',
    currency: 'MDL',
  },
  {
    name: 'Montenegro',
    code: 'ME',
    locale: 'sr-ME',
    currency: 'EUR',
  },
  {
    name: 'Saint Martin',
    code: 'MF',
    locale: 'fr-MF',
    currency: 'EUR',
  },
  {
    name: 'Madagascar',
    code: 'MG',
    locale: 'mg-MG',
    currency: 'MGA',
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
    locale: 'en-MH',
    currency: 'USD',
  },
  {
    name: 'North Macedonia',
    code: 'MK',
    locale: 'mk-MK',
    currency: 'MKD',
  },
  {
    name: 'Mali',
    code: 'ML',
    locale: 'fr-ML',
    currency: 'XOF',
  },
  {
    name: 'Myanmar [Burma]',
    code: 'MM',
    locale: 'my-MM',
    currency: 'MMK',
  },
  {
    name: 'Mongolia',
    code: 'MN',
    locale: 'mn-MN',
    currency: 'MNT',
  },
  {
    name: 'Macao',
    code: 'MO',
    locale: 'zh-MO',
    currency: 'MOP',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
    locale: 'en-MP',
    currency: 'USD',
  },
  {
    name: 'Martinique',
    code: 'MQ',
    locale: 'fr-MQ',
    currency: 'EUR',
  },
  {
    name: 'Mauritania',
    code: 'MR',
    locale: 'ar-MR',
    currency: 'MRU',
  },
  {
    name: 'Montserrat',
    code: 'MS',
    locale: 'en-MS',
    currency: 'XCD',
  },
  {
    name: 'Malta',
    code: 'MT',
    zone: 'eu',
    locale: 'mt-MT',
    currency: 'EUR',
  },
  {
    name: 'Mauritius',
    code: 'MU',
    locale: 'en-MU',
    currency: 'MUR',
  },
  {
    name: 'Maldives',
    code: 'MV',
    locale: 'dv-MV',
    currency: 'MVR',
  },
  {
    name: 'Malawi',
    code: 'MW',
    locale: 'en-MW',
    currency: 'MWK',
  },
  {
    name: 'Mexico',
    code: 'MX',
    locale: 'es-MX',
    currency: 'MXN',
  },
  {
    name: 'Malaysia',
    code: 'MY',
    locale: 'ms-MY',
    currency: 'MYR',
  },
  {
    name: 'Mozambique',
    code: 'MZ',
    locale: 'pt-MZ',
    currency: 'MZN',
  },
  {
    name: 'Namibia',
    code: 'NA',
    locale: 'en-NA',
    currency: 'NAD',
  },
  {
    name: 'New Caledonia',
    code: 'NC',
    locale: 'fr-NC',
    currency: 'XPF',
  },
  {
    name: 'Niger',
    code: 'NE',
    locale: 'fr-NE',
    currency: 'XOF',
  },
  {
    name: 'Norfolk Island',
    code: 'NF',
    locale: 'en-NF',
    currency: 'AUD',
  },
  {
    name: 'Nigeria',
    code: 'NG',
    locale: 'en-NG',
    currency: 'NGN',
  },
  {
    name: 'Nicaragua',
    code: 'NI',
    locale: 'es-NI',
    currency: 'NIO',
  },
  {
    name: 'Netherlands',
    code: 'NL',
    zone: 'eu',
    locale: 'nl-NL',
    currency: 'EUR',
  },
  {
    name: 'Norway',
    code: 'NO',
    locale: 'nb-NO',
    currency: 'NOK',
  },
  {
    name: 'Nepal',
    code: 'NP',
    locale: 'ne-NP',
    currency: 'NPR',
  },
  {
    name: 'Nauru',
    code: 'NR',
    locale: 'en-NR',
    currency: 'AUD',
  },
  {
    name: 'Niue',
    code: 'NU',
    locale: 'en-NU',
    currency: 'NZD',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    locale: 'en-NZ',
    currency: 'NZD',
  },
  {
    name: 'Oman',
    code: 'OM',
    locale: 'ar-OM',
    currency: 'OMR',
  },
  {
    name: 'Panama',
    code: 'PA',
    locale: 'es-PA',
    currency: 'PAB',
  },
  {
    name: 'Peru',
    code: 'PE',
    locale: 'es-PE',
    currency: 'PEN',
  },
  {
    name: 'French Polynesia',
    code: 'PF',
    locale: 'fr-PF',
    currency: 'XPF',
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
    locale: 'en-PG',
    currency: 'PGK',
  },
  {
    name: 'Philippines',
    code: 'PH',
    locale: 'en-PH',
    currency: 'PHP',
  },
  {
    name: 'Pakistan',
    code: 'PK',
    locale: 'ur-PK',
    currency: 'PKR',
  },
  {
    name: 'Poland',
    code: 'PL',
    zone: 'eu',
    locale: 'pl-PL',
    currency: 'PLN',
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
    locale: 'fr-PM',
    currency: 'EUR',
  },
  {
    name: 'Pitcairn Islands',
    code: 'PN',
    locale: 'en-PN',
    currency: 'NZD',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    locale: 'es-PR',
    currency: 'USD',
  },
  {
    name: 'Palestine',
    code: 'PS',
    locale: 'ar-PS',
    currency: 'ILS',
  },
  {
    name: 'Portugal',
    code: 'PT',
    zone: 'eu',
    locale: 'pt-PT',
    currency: 'EUR',
  },
  {
    name: 'Palau',
    code: 'PW',
    locale: 'en-PW',
    currency: 'USD',
  },
  {
    name: 'Paraguay',
    code: 'PY',
    locale: 'es-PY',
    currency: 'PYG',
  },
  {
    name: 'Qatar',
    code: 'QA',
    locale: 'ar-QA',
    currency: 'QAR',
  },
  {
    name: 'Réunion',
    code: 'RE',
    locale: 'fr-RE',
    currency: 'EUR',
  },
  {
    name: 'Romania',
    code: 'RO',
    zone: 'eu',
    locale: 'ro-RO',
    currency: 'RON',
  },
  {
    name: 'Serbia',
    code: 'RS',
    locale: 'sr-RS',
    currency: 'RSD',
  },
  {
    name: 'Russia',
    code: 'RU',
    locale: 'ru-RU',
    currency: 'RUB',
  },
  {
    name: 'Rwanda',
    code: 'RW',
    locale: 'rw-RW',
    currency: 'RWF',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    locale: 'ar-SA',
    currency: 'SAR',
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
    locale: 'en-SB',
    currency: 'SBD',
  },
  {
    name: 'Seychelles',
    code: 'SC',
    locale: 'fr-SC',
    currency: 'SCR',
  },
  {
    name: 'Sudan',
    code: 'SD',
    locale: 'ar-SD',
    currency: 'SDG',
  },
  {
    name: 'Sweden',
    code: 'SE',
    zone: 'eu',
    locale: 'sv-SE',
    currency: 'SEK',
  },
  {
    name: 'Singapore',
    code: 'SG',
    locale: 'en-SG',
    currency: 'SGD',
  },
  {
    name: 'Saint Helena',
    code: 'SH',
    locale: 'en-SH',
    currency: 'SHP',
  },
  {
    name: 'Slovenia',
    code: 'SI',
    zone: 'eu',
    locale: 'sl-SI',
    currency: 'EUR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
    locale: 'nb-SJ',
    currency: 'NOK',
  },
  {
    name: 'Slovakia',
    code: 'SK',
    zone: 'eu',
    locale: 'sk-SK',
    currency: 'EUR',
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
    locale: 'en-SL',
    currency: 'SLL',
  },
  {
    name: 'San Marino',
    code: 'SM',
    locale: 'it-SM',
    currency: 'EUR',
  },
  {
    name: 'Senegal',
    code: 'SN',
    locale: 'fr-SN',
    currency: 'XOF',
  },
  {
    name: 'Somalia',
    code: 'SO',
    locale: 'so-SO',
    currency: 'SOS',
  },
  {
    name: 'Suriname',
    code: 'SR',
    locale: 'nl-SR',
    currency: 'SRD',
  },
  {
    name: 'South Sudan',
    code: 'SS',
    locale: 'en-SS',
    currency: 'SSP',
  },
  {
    name: 'São Tomé and Príncipe',
    code: 'ST',
    locale: 'pt-ST',
    currency: 'STN',
  },
  {
    name: 'El Salvador',
    code: 'SV',
    locale: 'es-SV',
    currency: 'USD',
  },
  {
    name: 'Sint Maarten',
    code: 'SX',
    locale: 'nl-SX',
    currency: 'ANG',
  },
  {
    name: 'Syria',
    code: 'SY',
    locale: 'ar-SY',
    currency: 'SYP',
  },
  {
    name: 'Swaziland',
    code: 'SZ',
    locale: 'en-SZ',
    currency: 'SZL',
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
    locale: 'en-TC',
    currency: 'USD',
  },
  {
    name: 'Chad',
    code: 'TD',
    locale: 'fr-TD',
    currency: 'XAF',
  },
  {
    name: 'French Southern Territories',
    code: 'TF',
    locale: 'fr-TF',
    currency: 'EUR',
  },
  {
    name: 'Togo',
    code: 'TG',
    locale: 'fr-TG',
    currency: 'XOF',
  },
  {
    name: 'Thailand',
    code: 'TH',
    locale: 'th-TH',
    currency: 'THB',
  },
  {
    name: 'Tajikistan',
    code: 'TJ',
    locale: 'tg-TJ',
    currency: 'TJS',
  },
  {
    name: 'Tokelau',
    code: 'TK',
    locale: 'en-TK',
    currency: 'NZD',
  },
  {
    name: 'East Timor',
    code: 'TL',
    locale: 'pt-TL',
    currency: 'USD',
  },
  {
    name: 'Turkmenistan',
    code: 'TM',
    locale: 'tk-TM',
    currency: 'TMT',
  },
  {
    name: 'Tunisia',
    code: 'TN',
    locale: 'ar-TN',
    currency: 'TND',
  },
  {
    name: 'Tonga',
    code: 'TO',
    locale: 'en-TO',
    currency: 'TOP',
  },
  {
    name: 'Turkey',
    code: 'TR',
    locale: 'tr-TR',
    currency: 'TRY',
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
    locale: 'en-TT',
    currency: 'TTD',
  },
  {
    name: 'Tuvalu',
    code: 'TV',
    locale: 'en-TV',
    currency: 'AUD',
  },
  {
    name: 'Taiwan',
    code: 'TW',
    locale: 'zh-TW',
    currency: 'TWD',
  },
  {
    name: 'Tanzania',
    code: 'TZ',
    locale: 'sw-TZ',
    currency: 'TZS',
  },
  {
    name: 'Ukraine',
    code: 'UA',
    locale: 'uk-UA',
    currency: 'UAH',
  },
  {
    name: 'Uganda',
    code: 'UG',
    locale: 'en-UG',
    currency: 'UGX',
  },
  {
    name: 'U.S. Minor Outlying Islands',
    code: 'UM',
    locale: 'en-UM',
    currency: 'USD',
  },
  {
    name: 'United States',
    code: 'US',
    zone: 'us',
    locale: 'en-US',
    currency: 'USD',
  },
  {
    name: 'Uruguay',
    code: 'UY',
    locale: 'es-UY',
    currency: 'UYU',
  },
  {
    name: 'Uzbekistan',
    code: 'UZ',
    locale: 'uz-UZ',
    currency: 'UZS',
  },
  {
    name: 'Vatican City',
    code: 'VA',
    locale: 'it-VA',
    currency: 'EUR',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
    locale: 'en-VC',
    currency: 'XCD',
  },
  {
    name: 'Venezuela',
    code: 'VE',
    locale: 'es-VE',
    currency: 'VES',
  },
  {
    name: 'British Virgin Islands',
    code: 'VG',
    locale: 'en-VG',
    currency: 'USD',
  },
  {
    name: 'U.S. Virgin Islands',
    code: 'VI',
    locale: 'en-VI',
    currency: 'USD',
  },
  {
    name: 'Vietnam',
    code: 'VN',
    locale: 'vi-VN',
    currency: 'VND',
  },
  {
    name: 'Vanuatu',
    code: 'VU',
    locale: 'en-VU',
    currency: 'VUV',
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
    locale: 'fr-WF',
    currency: 'XPF',
  },
  {
    name: 'Samoa',
    code: 'WS',
    locale: 'en-WS',
    currency: 'WST',
  },
  {
    name: 'Kosovo',
    code: 'XK',
    locale: 'sq-XK',
    currency: 'EUR',
  },
  {
    name: 'Yemen',
    code: 'YE',
    locale: 'ar-YE',
    currency: 'YER',
  },
  {
    name: 'Mayotte',
    code: 'YT',
    locale: 'fr-YT',
    currency: 'EUR',
  },
  {
    name: 'South Africa',
    code: 'ZA',
    locale: 'en-ZA',
    currency: 'ZAR',
  },
  {
    name: 'Zambia',
    code: 'ZM',
    locale: 'en-ZM',
    currency: 'ZMW',
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
    locale: 'en-ZW',
    currency: 'ZWL',
  },
];

export const shopifyMarketCountries = [{
  name: 'United States',
  code: 'US',
  zone: 'us',
  locale: 'en-US',
  currency: 'USD',
},
{
  name: 'United Kingdom',
  code: 'GB',
  zone: 'us',
  locale: 'en-GB',
  currency: 'GBP',
},
{
  name: 'Germany',
  code: 'DE',
  zone: 'eu',
  locale: 'de-DE',
  currency: 'EUR',
},
{
  name: 'Canada',
  code: 'CA',
  locale: 'en-CA',
  currency: 'CAD',
},
{
  name: 'Australia',
  code: 'AU',
  zone: 'us',
  locale: 'en-AU',
  currency: 'AUD',
},
{
  name: 'New Zealand',
  code: 'NZ',
  locale: 'en-NZ',
  currency: 'NZD',
},
]